import styles from './index.module.scss';
import TextInput from "@/app/_components/Shared/TextInput";
import MailGray from "@/app/icons/mail-gray.svg";
import UserIcon from "@/app/icons/user.svg";

// Radio button options
const options = [
    'Any',
    'Email',
    'Phone',
    'WhatsApp',
    'Video Call',
];

export default function PersonalDetails({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Enter Your Details</h2>
            <TextInput placeholder="Your Name" required icon={UserIcon} value={data.full_name} onChange={(e) => onChange('full_name', e.target.value)}/>
            <TextInput type="email" placeholder="Email" required icon={MailGray} value={data.email} onChange={(e) => onChange('email', e.target.value)}/>
            <TextInput type="phone" placeholder="Phone" required value={data.phone} onChange={(value) => onChange('phone', value)}/>
            <div className={styles.radio}>
                <span>Preferred Contact Method</span>
                <div className={styles.options}>
                    {options.map((option, index) => (
                        <label key={index}>
                            <input type="radio" name="preferred_contact_method" value={option} checked={data.preferred_contact_method === option} onChange={() => onChange('preferred_contact_method', option)}/>
                            {option}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    )
}